<div class="bg-image-container position-relative">
  <div class="background-image-full position-absolute" style=" background-position: left top;" [lazyLoad]="data.biBackgroundImage.sizes.large" [defaultImage]="data.biBackgroundImage.sizes.thumbnail">
  </div>
  <div class="gradient-layer">

  </div>
</div>
